import { Link } from '@apia/theme';
import React from 'react';
import IProperty from '../../../../JSApi/constants/IProperty';
import MakeField from '../fieldsStore/MakeField';
import useContext from '../../../../hooks/useContext';
import FieldContext from '../fieldsStore/FieldContext';
import useApiaFieldCommonProps from './useApiaFieldCommonProps';
import { ApiaComponentContextPrimitive } from '../apiaComponent/ApiaComponentContext';
import usePropsSelector from '../../../../store/propsStore/usePropsSelector';

const ApiaLink = MakeField(
  React.forwardRef<HTMLAnchorElement>((_, ref) => {
    const {
      state: { value },
    } = useContext(FieldContext);
    const { fieldId } = useContext(ApiaComponentContextPrimitive);
    const props = usePropsSelector(fieldId);

    const { identifier } = useApiaFieldCommonProps({
      className: 'link__field',
    });

    return (
      <Link
        {...window.getVariant('layout.execution.form.fields.link')}
        {...identifier}
        href={props[IProperty.PROPERTY_URL]}
        title={props[IProperty.PROPERTY_TOOLTIP]}
        aria-label={value as string}
        target={props[IProperty.PROPERTY_URL] ? '_blank' : undefined}
        rel="noreferrer"
        ref={ref}
        sx={{
          ':hover,:focus': (theme) => {
            return {
              color: theme.palette.darkenColor('link', 12),
              textDecoration: 'underline',
            };
          },
        }}
      >
        {value as string}
      </Link>
    );
  }),
  {
    preSynchronize() {
      return true;
    },
    doSynchronize() {
      return true;
    },
  },
);

export default ApiaLink;
